module.exports = __webpack_public_path__ + "static/media/JonathanLai.717d3450.jpg";